module.exports = __webpack_public_path__ + "assets/img/bp_d_i_17.5cc56928.jpg";